import { useEffect, useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { http, formatError } from "@/lib/api";
import { SETTINGS_GROUPS } from "./schemas";
import { FieldInput } from "./FieldInput";

export const SettingsEditor = () => {
  const qc = useQueryClient();
  const [s, setS] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    http.get("/admin/settings").then((r) => setS(r.data || {})).catch((e) => toast.error(formatError(e)));
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      const r = await http.put("/admin/settings", s);
      setS(r.data);
      qc.invalidateQueries({ queryKey: ["settings"] });
      toast.success("Settings saved");
    } catch (e) { toast.error(formatError(e)); }
    setSaving(false);
  };

  if (!s) return <Loader2 className="h-6 w-6 animate-spin text-[#7C3AED]" />;
  return (
    <div data-testid="admin-settings">
      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-extrabold text-[#13052A]">Site settings</h2>
        <button onClick={save} disabled={saving} className="btn-primary !py-2.5" data-testid="admin-settings-save">{saving ? <Loader2 className="h-4 w-4 animate-spin" /> : "Save settings"}</button>
      </div>
      <div className="mt-6 space-y-6">
        {SETTINGS_GROUPS.map(([title, fields]) => (
          <section key={title} className="rounded-2xl border border-violet-200 bg-white p-6">
            <h3 className="text-base font-extrabold text-[#13052A]">{title}</h3>
            <div className="mt-4 grid gap-4 md:grid-cols-2">
              {fields.map((f) => (
                <div key={f.key} className={f.type === "textarea" ? "md:col-span-2" : ""}>
                  <FieldInput f={f} value={s[f.key]} onChange={(v) => setS((p) => ({ ...p, [f.key]: v }))} />
                </div>
              ))}
            </div>
          </section>
        ))}
      </div>
    </div>
  );
};
